import { call, put } from 'redux-saga/effects';
import { retriable } from '../retriable';
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    isValidFunction,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import messages from '../../constants/messages';
import {
    CREATE_PRODUCT_TAG_FAILURE,
    CREATE_PRODUCT_TAG_SUCCESS,
    FETCH_PRODUCT_TAG_LIST_FAILURE,
    FETCH_PRODUCT_TAG_LIST_SUCCESS,
    INACTIVATE_PRODUCT_TAG_SUCCESS,
    INACTIVATE_PRODUCT_TAG_FAILURE,
    ACTIVATE_PRODUCT_TAG_SUCCESS,
    ACTIVATE_PRODUCT_TAG_FAILURE,
} from '../../redux/modules/productTag/productTag-actions';

export function* fetchPagesOfProductTagWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().get, action.api);
        yield put({
            type: FETCH_PRODUCT_TAG_LIST_SUCCESS,
            data: response.data,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.PRODUCT_TAG.FETCH_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: FETCH_PRODUCT_TAG_LIST_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export function* createProductTagWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().post, action.api, action.productTag);
        yield put({
            type: CREATE_PRODUCT_TAG_SUCCESS,
            data: response.data,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
        if (action.isUpdate) {
            yield put({ type: SUCCESS_MESSAGE, message: messages.PRODUCT_TAG.UPDATE.SUCCESS });
        } else {
            yield put({ type: SUCCESS_MESSAGE, message: messages.PRODUCT_TAG.CREATE.SUCCESS });
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            let msg = messages.PRODUCT_TAG.CREATE.FAILED;
            if (action.isUpdate) {
                msg = messages.PRODUCT_TAG.UPDATE.FAILED;
            }
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: CREATE_PRODUCT_TAG_FAILURE, data: action.payload });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export function* inactivateProductTagWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        yield call(retriable().delete, action.api);
        yield put({ type: INACTIVATE_PRODUCT_TAG_SUCCESS });
        yield put({ type: SUCCESS_MESSAGE, message: messages.PRODUCT_TAG.INACTIVATE.SUCCESS });
        if (isValidFunction(action.successCallback)) {
            action.successCallback();
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.PRODUCT_TAG.INACTIVATE.FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: INACTIVATE_PRODUCT_TAG_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export function* activateProductTagWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        yield call(retriable().get, action.api);
        yield put({ type: ACTIVATE_PRODUCT_TAG_SUCCESS });
        yield put({ type: SUCCESS_MESSAGE, message: messages.PRODUCT_TAG.ACTIVATE.SUCCESS });
        if (isValidFunction(action.successCallback)) {
            action.successCallback();
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.PRODUCT_TAG.ACTIVATE.FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: ACTIVATE_PRODUCT_TAG_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
